import { render } from "./payment-header.vue?vue&type=template&id=370744fa&scoped=true"
import script from "./payment-header.vue?vue&type=script&lang=js"
export * from "./payment-header.vue?vue&type=script&lang=js"

import "./payment-header.vue?vue&type=style&index=0&id=370744fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370744fa"]])

export default __exports__